// The one Firestore read of `userProfile` -- views never touch `db`, the same
// contract bookingService / dispatchService / driverService keep. One snapshot
// listener for the whole session: a few hundred small documents at most, and
// staying live means a name an administrator fixes shows up without a reload.
const { db } = require('@/firebase')

function subscribe (onProfiles, onError) {
  return db.collection('userProfile').onSnapshot(snap => {
    const profiles = []
    snap.forEach(d => profiles.push(Object.assign({ uid: d.id }, d.data())))
    onProfiles(profiles)
  }, onError)
}

// Booking groups, for ผู้ใช้งานระบบ. Written only by the setBookingGroup callable.
function subscribeGroups (onGroups, onError) {
  return db.collection('bookingGroup').onSnapshot(snap => {
    const groups = []
    snap.forEach(d => groups.push(Object.assign({ id: d.id }, d.data())))
    groups.sort((a, b) => String(a.label).localeCompare(String(b.label)))
    onGroups(groups)
  }, onError)
}

module.exports = { subscribe, subscribeGroups }
